// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"a8e9e401","656":"896af8c5","756":"7c78dc76","831":"5146b857","968":"14d5a22a"}[chunkId] + ".chunk.js";
};